var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer-checkout"},[_c('vb-checkbox',{attrs:{"vb_options":{
      type: 'light',
      size: 'lg',
      text: 'Ho preso visione delle indicazioni di sicurezza e delle normative doganali e sanitarie di accesso a questa destinazione sul sito <a href=\'https://www.viaggiaresicuri.it\' target=\'_blank\'>Viaggiare sicuri</a> del Ministero degli esteri italiano.',
    }},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }